import { CloseOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Layout, Tooltip } from "antd";
import { createGlobalStyle } from 'styled-components';
import WidgetIdsSelectionTree from '../../../components/WidgetIdsSelectionTree';
import User from 'graphql/User/User';

const { Sider } = Layout

const GlobalStyle = createGlobalStyle`
/* 
  .ant-layout-sider-zero-width-trigger {
    display: flex;
    align-items: center;
    justify-content: center;
    top: 0;
    background: #2d517354;
    color: black;
    height: 64px;
    z-index: 1;

    :hover {
      background: #2d517399;
    }
  }
 */
`

export interface Props {
  onClose: (e: any) => void
  user: User
  collapsed: boolean
  onWidgetIdsSelectionChange: (selectedWidgetIds: string[]) => void
  onRefetchAgencies?: () => void
  selectedWidgetIds: string[]
}

const DashboardRightSider = (props: Props) => {
  const { collapsed, onClose, user, selectedWidgetIds, onWidgetIdsSelectionChange, onRefetchAgencies } = props

  return <>
    <GlobalStyle />
    <Sider
      collapsed={collapsed}
      style={{ background: '#fff', overflowY: 'auto' }}
      collapsedWidth={0}
      width={300}
    >
      <div
        style={{
          padding: '16px',
          borderBottom: '1px solid #f0f0f0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            color: 'rgba(0,0,0,.85)',
            fontWeight: 500,
            fontSize: '16px',
            lineHeight: '22px',
          }}
        >
          Selecionar filiais
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          {onRefetchAgencies &&
            <Tooltip title='Recarregar dados'>
              <Button onClick={onRefetchAgencies} shape='circle' type='text' icon={<ReloadOutlined />} />
            </Tooltip>
          }
          <Button onClick={onClose} shape='circle' type='text' icon={<CloseOutlined />} />
        </div>
      </div>

      <div
        style={{
          padding: '16px 8px',
          overflow: 'auto',
        }}
      >
        <WidgetIdsSelectionTree
          user={user}
          onWidgetIdsCheckedChange={onWidgetIdsSelectionChange}
          checkedWidgetIds={selectedWidgetIds}
          enableCopyToClipboard={user && user.role === 'FIREFLY_ADMIN'}
        />
      </div>

    </Sider>
  </>;
}

export default DashboardRightSider;
